<template>
	<div class="introducer" :class="{ 'introducer--reverse': reverse }">
		<div
			v-for="(image, index) in images"
			class="introducer__image">
			<parallax :speed-factor="0.3" >
				<img :src="image" />
			</parallax>
		</div>
		<div class="introducer__content">
			<div :class="{ 'introducer__wrapper': images.length == 1 }">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
import Parallax from 'vue-parallaxy'
export default {
	components: { Parallax },

	mounted () {

	},

	data () {
		return {

		}
	},

	props: {
		image: Object,
		imageExtra: Object,
		reverse: Boolean
	},

	computed: {
		images () {
			return this.imageExtra ? [this.image, this.imageExtra] : [this.image];
		}
	},

	methods: {

	}
}
</script>
<style scoped>
	.introducer { display: flex; position: relative; overflow: hidden; align-items: center; min-height: 500px; }
	.introducer--reverse { flex-direction: row-reverse; }
	.introducer__content { flex:1; order: 1; padding: 0 40px; }
	.introducer__image { flex: 1; padding-top: 40px;  }
	.introducer__image:nth-child(1) { order: 0; }
	.introducer__image:nth-child(2) { order: 2; }
	.introducer__wrapper { width: 96%; max-width: calc(1280px / 2); float: right; }

	@media (max-width: 900px) {
		.introducer__image { display: none; }
		.introducer__content { flex: 1 1 100%; text-align: center; padding: 40px; }
	}

</style>
<style>
	.Masthead { max-height: 500px!important; min-height: 0!important; }
	.Masthead__image.is-parallax>img { object-position: right!important; }
	:not(.introducer--reverse) .introducer__image:nth-child(2) .Masthead__image.is-parallax>img,
	.introducer--reverse .introducer__image:nth-child(1) .Masthead__image.is-parallax>img { object-position: left!important; }
</style>